import React, { useState, useEffect } from 'react';
import Sidebar from '../components/common/Sidebar';
import TopBar from '../components/common/TopBar';

interface MainLayoutProps {
  children: React.ReactNode;
  title?: string;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, title }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Close mobile sidebar when clicking outside
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMobileOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
      
      <div className="flex-1 flex flex-col lg:ml-80">
        <TopBar onMenuClick={handleDrawerToggle} title={title} />
        
        <main className="flex-1 overflow-auto pt-16">
          <div className="px-4 sm:px-6 lg:px-8 py-8 max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;

